module.exports = __webpack_public_path__ + "img/flexue.6c938d5e.png";